import DeleteIcon from '@mui/icons-material/Delete';
import { Stack, Typography } from '@mui/material';

import { Flex } from 'src/components/Flex';

interface FilePreviewerProps {
    onRemove: () => void;
}

const FilePreviewer = ({ onRemove }: FilePreviewerProps) => {
    return (
        <Flex justifyContent="flex-end">
            <Stack
                direction="row"
                alignItems="center"
                sx={{
                    cursor: 'pointer',
                }}
                onClick={onRemove}
            >
                <Typography
                    sx={{
                        color: 'error.main',
                        fontSize: '14px',
                    }}
                >
                    Remove
                </Typography>
                <DeleteIcon
                    sx={{
                        fontSize: '14px',
                        color: 'error.main',
                    }}
                />
            </Stack>
        </Flex>
    );
};

export default FilePreviewer;
